import axios from 'axios'
import store from '@store/index'
import router from '@router/index'
import { LocalStorage } from 'quasar'
import { get } from 'lodash'

let numberOfAjaxCAllPending = 0
export const axiosInstance = axios.create({
  headers: {},
  withCredentials: true,
  baseURL: process.env.VUE_APP_API_PREFIX
})
axiosInstance.interceptors.request.use(
  config => {
    ++numberOfAjaxCAllPending
    const authorizeTokenKey = `${store.getters.tenant}_authorization`
    const token = LocalStorage.getItem(authorizeTokenKey)
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json;charset=utf-8'
    }
    config.headers = config.headers || {}
    if (token) {
      config.headers['Authorization'] = token
    }

    if (config.method === 'get') {
      const source = axios.CancelToken.source()
      config.cancelToken = source.token
      store.commit('requests/add', source)
    }

    return config
  },
  err => {
    store.dispatch(
      'createNotificationToast',
      {
        message: [get(err, 'message') ? err.message : 'Unknown error']
      },
      { root: true }
    )
    return Promise.reject(err)
  }
)

axiosInstance.interceptors.response.use(
  response => {
    --numberOfAjaxCAllPending
    if (numberOfAjaxCAllPending === 0) store.dispatch('handleGlobalLoader', false, { root: true })
    const token = response.headers['authorization'] || response.headers['Authorization']
    if (token) {
      LocalStorage.set(`${store.getters.tenant}_authorization`, token)
      store.commit('updateAccessToken', token, { root: true })
    }
    if (response.data.user) {
      store.commit('updateUser', response.data.user)
      LocalStorage.set(`${store.getters.tenant}_user`, response.data.user)
    }
    if (response.config.method !== 'get') {
      const messages = get(response, 'data.messages.default')

      if (messages) {
        store.dispatch(
          'createNotificationToast',
          {
            message: messages,
            color: get(response, 'data.status')
          },
          { root: true }
        )
      }
    }
    return response
  },
  err => {
    --numberOfAjaxCAllPending
    store.dispatch('handleGlobalLoader', false, { root: true })
    let responseMessages = get(err, 'response.data.messages.default')
    if (get(err, 'response')) {
      if (err.response.status === 401) {
        if (get(store, 'state.requestCancellationToken')) store.state.requestCancellationToken.cancel()
        LocalStorage.remove(`${store.getters.tenant}_authorization`)
        LocalStorage.remove(`${store.getters.tenant}_user`)
        store.dispatch(
          'createNotificationToast',
          {
            message: responseMessages,
            color: get(err, 'response.data.status')
          },
          { root: true }
        )
        store.dispatch('resetState')
        if (store.state.route.name !== 'login') {
          router.push({
            name: 'login',
            query: { redirect: store.state.route.fullPath }
          })
        }
      } else if (err.response.status === 404) {
        store.dispatch(
          'createNotificationToast',
          {
            message: [responseMessages[0] || 'Unknown error'],
            color: 'negative'
          },
          { root: true }
        )
      } else if (err.response.status === 422) {
        store.dispatch('handleValidationMessages', get(err, 'response.data.messages.errors'), { root: true })
        if (err.response.data.result) {
          return Promise.reject(err)
        }
      } else if ([409, 503].includes(err.response.status)) {
        store.dispatch(
          'createNotificationToast',
          {
            message: responseMessages,
            color: get(err, 'response.data.status')
          },
          { root: true }
        )
      } else if (RegExp('^5[0-9]').test(err.response.status)) {
        store.dispatch(
          'createNotificationToast',
          {
            message: ['An error occurred. We have been notified!'],
            color: 'negative'
          },
          { root: true }
        )
      } else if (
        err.response.status === 403 &&
        err.response.data.messages.default[0] === 'User does not have the right permissions.'
      ) {
        store.dispatch(
          'createNotificationToast',
          {
            message: ['You don´t have permissions to perform this action'],
            color: 'negative'
          },
          { root: true }
        )
      } else {
        store.dispatch(
          'createNotificationToast',
          {
            message: ['Unknown error.'],
            color: 'negative'
          },
          { root: true }
        )
      }
    }
    return Promise.reject(err)
  }
)
